import {Item} from './item';

export class ItemCollection {
    private totalItems: number = 0;
    private items: Item[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setItems(items: Item[]) {
        this.items = items;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getItems(): Item[] {
        return this.items;
    }
}
